import { NODE_BASE_URL } from './serviceHelper'

export const authService = {
  login: async (email, password, companyId) => {
    const response = await fetch(process.env.REACT_APP_NODE_BASE_URL + '/user/auth/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password, company_id: companyId }),
    })
    const json = await response.json()

    return { json, response }
  },
  isUserExist: async (email, companyId) => {
    const res = await fetch(
      `${NODE_BASE_URL}/user/auth/user-exists/${email}?company_id=${companyId}`
    )
    return await res.json()
  },
  getCompanyDetails: async (companyId) => {
    const res = await fetch(`${NODE_BASE_URL}/user/auth/company/${companyId}`)
    return await res.json()
  },
  sendOtp: async (email) => {
    const res = await fetch(`${NODE_BASE_URL}/user/auth/generate-otp`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email,
      }),
    })
    return await res.json()
  },
  verifyOtp: async (email, otp) => {
    const res = await fetch(`${NODE_BASE_URL}/user/auth/verify-otp`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email,
        otp,
      }),
    })
    return await res.json()
  },

  resetPassword: async (email, password, otp) => {
    const res = await fetch(`${NODE_BASE_URL}/user/auth/reset-password`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email,
        password,
        otp,
      }),
    })
    return await res.json()
  },

  sendOnboardingOtp: async (data) => {
    const res = await fetch(`${NODE_BASE_URL}/user/auth/send-onboarding-otp`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
    return await res.json()
  },
  verifyOnboardingOtp: async (data) => {
    const res = await fetch(`${NODE_BASE_URL}/user/auth/verify-onboarding-otp`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
    return await res.json()
  },
  updateUserDetails: async (data) => {
    const res = await fetch(`${NODE_BASE_URL}/user/auth/update-user-details`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
    return await res.json()
  },
  createCompany: async (data) => {
    const res = await fetch(`${NODE_BASE_URL}/user/auth/create-company`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    })
    return await res.json()
  },
}
